import { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import { Container, Col, Row } from 'reactstrap';
import { toPrivacy, toTermsOfService } from '../../routes';

const FooterCopyright = () => {
  const [currentYear, setCurrentYear] = useState<number | null>(null);
  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, []);

  return (
    <Container fluid className="pb-3">
      <Row style={{ height: '5px' }} className="mb-3">
        <Col xs="4" className="bg-primary"></Col>
        <Col xs="4" className="bg-success"></Col>
        <Col xs="4" className="bg-secondary"></Col>
      </Row>
      <Row className="justify-content-center w-100 gap-2">
        <Col md="auto" className="dp-font-xs text-center">
          <p className="fs-xs mb-0">
            &copy; Copyright {currentYear} DentalPost, Inc. All rights reserved.
          </p>
        </Col>
        <Col xs="auto" className="dp-font-xs">
          <Link to={toTermsOfService} className="text-start fs-xs link-black">
            Terms Of Service
          </Link>
        </Col>
        <Col xs="auto" className="dp-font-xs">
          <Link to={toPrivacy} className="text-start link-black">
            Privacy Policy
          </Link>
        </Col>
      </Row>
    </Container>
  );
};

export default FooterCopyright;
